// Generic, failure-proof localStorage helpers. Storage can be missing or throw
// (private windows, blocked site data, quota) and the game must still run, so
// every access -- including reaching for localStorage itself -- is wrapped.

function resolve(storage) {
  return storage === undefined ? globalThis.localStorage : storage;
}

/**
 * The parsed value saved under `key`, or null when there's none, it can't be
 * parsed, it fails `validate`, or storage is unavailable.
 */
export function loadJSON(key, validate = () => true, storage) {
  try {
    const raw = resolve(storage).getItem(key);
    if (raw == null || raw === '') return null;
    const value = JSON.parse(raw);
    return validate(value) ? value : null;
  } catch {
    return null;
  }
}

/** Save `value` as JSON under `key`. Returns false when it couldn't be saved. */
export function saveJSON(key, value, storage) {
  try {
    resolve(storage).setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}
